import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, TableContainer, TableBody } from '@mui/material';
import { WeightedTableRow } from '../../Table/WeightedTableRow';
import OverviewCard from './OverviewCard';

const PeopleCard = ({ customer }) => {
  const { t } = useTranslation();
  return (
    <OverviewCard header={t('components.cards.people.people')}>
      {customer && (
        <TableContainer>
          <Table borderless size="sm">
            <TableBody>
              <WeightedTableRow header={t('components.cards.people.numberOfPeople')} value={customer.numberOfPeople} />
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </OverviewCard>
  );
};

PeopleCard.propTypes = {
  customer: PropTypes.shape({
    numberOfPeople: PropTypes.number.isRequired,
  }),
};

export default PeopleCard;
